import { buildErrorsFromResponse } from '../../../core/js/utils/errorHandling';

export const PROFILE_AVAILABILITY_ERROR = 'PROFILE_AVAILABILITY_ERROR';
export const LOYALTY_SIGNUP_FAILURE = 'LOYALTY_SIGNUP_FAILURE';
export const PROFILE_AVAILABILITY_SUCCESS = 'PROFILE_AVAILABILITY_SUCCESS';
export const SAVE_LOYALTY_VALIDATION = 'SAVE_LOYALTY_VALIDATION';
export const LOYALTY_SIGNUP_SUCCESS = 'LOYALTY_SIGNUP_SUCCESS';
export const LOYALTY_LOGIN_SUCCESS = 'LOYALTY_LOGIN_SUCCESS';
export const SAVE_LOYALTY_FORM_DATA = 'SAVE_LOYALTY_FORM_DATA';
export const SET_LOYALTY_BIRTHDAY_YEARS = 'SET_LOYALTY_BIRTHDAY_YEARS';
export const SET_LOYALTY_BIRTHDAY_ORDER = 'SET_LOYALTY_BIRTHDAY_ORDER';

export function profileAvailabilityError(error) {
    return {
        type: PROFILE_AVAILABILITY_ERROR,
        payload: {
            code: error.entity.code
        }
    };
}

export function loyaltySignupFailure(response) {
    const payload = buildErrorsFromResponse(response);

    return {
        type: LOYALTY_SIGNUP_FAILURE,
        error: true,
        payload: payload
    };
}

export function profileAvailabilitySuccess() {
    return {
        type: PROFILE_AVAILABILITY_SUCCESS
    };
}

export function saveLoyaltyValidation(values, msgs) {
    return {
        type: SAVE_LOYALTY_VALIDATION,
        payload: {
            values: values,
            msgs: msgs
        }
    };
}

export function loyaltySignupSuccess() {
    return {
        type: LOYALTY_SIGNUP_SUCCESS
    };
}

export function loyaltyLoginSuccess() {
    return {
        type: LOYALTY_LOGIN_SUCCESS
    };
}

export function saveLoyaltyFormData(payload) {
    return {
        type: SAVE_LOYALTY_FORM_DATA,
        payload: payload
    };
}

export function setLoyaltyBirthdayYears(payload) {
    return {
        type: SET_LOYALTY_BIRTHDAY_YEARS,
        payload: payload
    };
}

export function setLoyaltyBirthdayOrder(payload) {
    return {
        type: SET_LOYALTY_BIRTHDAY_ORDER,
        payload: payload
    };
}
